import SetAdminPassword from './SetAdminPassword';

export default SetAdminPassword;